import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-622e0480")

_pushScopeId("data-v-622e0480")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确 认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.title,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
    width: "400px",
    "close-on-click-modal": false,
    onClose: _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _ctx.loading,
        onClick: _ctx.onValidate
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withId(() => [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.formData,
        ref: "refFrom",
        rules: _ctx.rules,
        "label-width": "130px",
        inline: false
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "品牌名称:",
            prop: "name"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event)),
                placeholder: "请输入",
                maxlength: "16"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "字母:",
            prop: "brandLetter"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.brandLetter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.brandLetter = $event)),
                placeholder: "请输入",
                maxlength: "1"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
})